import { ClientUserGroup } from './client-user-group'
import { UserRole } from './user-role'

export class ClientUser {
  // cosmos db item id
  id?: string
  clientCode?: string
  userId?: string
  ssoEmail?: string
  fullName?: string
  status?: 'active' | 'inactive'
  userRoles?: string[]
  userRolesDetails?: UserRole[]
  registrationStatus?: string
  emailValidated?: boolean
  mappedDoctorCodes?: string[]
  mappedCompanyCodes?: string[]
  doctorCompanyMappings?: string[];
  [key: string]: any // Add index signature
  createdAt?: number
  updatedAt?: number
  _etag?: string // Required for optimistic concurrency control
  settings?: {
    theme?: {
      darkMode?: boolean
    }
    reportSearch?: {
      defaultDateRangeDays?: number
    }
  }

  clientUserGroups?: Partial<ClientUserGroup>[]

  // toString()
  toString() {
    return JSON.stringify(this)
  }
}
